import React, { FC, ReactNode } from "react";
import { EPGAdminSidebar } from "./components/Sidebar";
import AdminLayout from "./AdminLayout";


interface Props {
    heading: ReactNode;
    sidebar?: React.ReactNode
    children?: ReactNode;
}

export const EPGAdminLayout: FC<Props> = ({
    heading,
    sidebar = <EPGAdminSidebar />,
    children,
}) => {
    return (
        <AdminLayout heading={heading} sidebar={sidebar}>
        {children}
        </AdminLayout>
    );
};

export default EPGAdminLayout;